module.exports = __webpack_public_path__ + "static/media/cube_s.15569614.svg";